import { notification } from 'antd';

const setNotification = ({ type, ...rest }) => {
  notification[type]({
    ...rest,
    duration: 3,
  });
};

export default setNotification;
